var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CustomBlipLineChart',_vm._b({attrs:{"request-status":_vm.requestStatus,"series":_vm.series,"title":_vm.title,"item-id":_vm.itemId,"card-options":_vm.cardOptions},on:{"reload":_vm.getData}},'CustomBlipLineChart',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }